// Port of api/fuel/app/classes/model/platform/voting/vote.php
import Model from 'offline/stream/model/base'

export default Model.extend({
	table: 'platform_voting_vote',
	prefix: 'vote',
	key: 'vote_id',
	fields: {
		vote_id: Model.SCHEMA_KEY,
		user_id: Model.SCHEMA_NUMBER,
		feature_id: Model.SCHEMA_NUMBER,
		vote_date: Model.SCHEMA_DATE_CREATE,
		vote_count: Model.SCHEMA_NUMBER,
		vote_stamp: Model.SCHEMA_TEXT
	}
})
